export const PSRServicesToTextSummary = {
  billInAudio: "Audio CD bill",
  billInBraille: "Braille format bill",
  billInLargePrint: "Large printed bill",
  passPhrase: "Password to identify us",
  quarterlyMeterRead: "Meter reads on your behalf",
  sendKnobTurner: "Contour knob turner",
};

export const defaultSelectedPSRServices = {
  quarterlyMeterRead: false,
  billInAudio: false,
  billInLargePrint: false,
  billInBraille: false,
  sendKnobTurner: false,
  passPhrase: false,
  none: false,
};

export enum PSRServicesSelectionDataTest {
  IMAGE_CUSTOMER = "IMAGE_CUSTOMER",
  SERVICE_OPTION_LABEL_TITLE = "SERVICE_OPTION_LABEL_TITLE",
  PASSPHRASE_INPUT_CONTAINER = "PASSPHRASE_INPUT_CONTAINER",
  PASSPHRASE_INPUT = "PASSPHRASE_INPUT",
  SERVICES_CHECKBOX = "SERVICES_CHECKBOX",
}